/* unplugin-vue-components disabled */import { render } from "./TopContent.vue?vue&type=template&id=2a68e7ba&scoped=true"
const script = {}

import "./TopContent.vue?vue&type=style&index=0&id=2a68e7ba&lang=scss&scoped=true"

import exportComponent from "D:\\pangu_artificial_intelligence_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a68e7ba"]])

export default __exports__